import { action, makeObservable, observable } from 'mobx';

export class WorkerStore {

  showNewVersionBanner: boolean;
  isOnline: boolean;
  showMaintenanceWindow: boolean;

  constructor() {
    this.showNewVersionBanner = false;
    this.showMaintenanceWindow = false;
    makeObservable(this, {
      showNewVersionBanner: observable,
      isOnline: observable,
      showMaintenanceWindow: observable,
      setShowNewVersionBanner: action,
      setIsOnline: action,
      setShowMaintenanceWindow: action,
    });
  }

  setShowNewVersionBanner(showNewVersionBanner) {
    this.showNewVersionBanner = showNewVersionBanner;
  }

  setIsOnline(isOnline) {
    this.isOnline = isOnline;
  }

  setShowMaintenanceWindow(value) {
    this.showMaintenanceWindow = value;
  }
}
